import service from "fetchers";

const partnershipApi = {
  getImagePartnership: ({ body }) =>
    service.post("/dashboard/product/partnership/get/pictures", body),
  addAccountPartnership: ({ body }) =>
    service.post("/iam/v1/admin/user/create", body),
  getAllAccountRolePartnership: ({ params }) =>
    service.get("/iam/v1/admin/roles/get/all", { params })
};

export default partnershipApi;
